import type { ToolUseItem } from '../../../../contracts/harness.types';

import type { LatestTodoPlan } from './computeLatestTodoPlan';
import type { TodoState } from './types';

/** The plan state the card at this row shows, when the row anchors a plan. */
export const planStateAt = (
  plan: LatestTodoPlan | null | undefined,
  itemId: string
): TodoState | undefined =>
  !plan
    ? undefined
    : itemId === plan.anchorId
      ? plan.state
      : plan.supersededByAnchorId.get(itemId);

/** A one-step plan repeats its step's own row, so it keeps a card only once approved. */
export const showsPlanCard = (item: ToolUseItem, state: TodoState | undefined): boolean =>
  !!state && (state.items.length >= 2 || item.approval?.status === 'approved');
